import { Base } from "ui/Scripts/source/framework/base";
import { CompanyGroupListItemCompany, ICompanyGroupListItemCompany } from "./companyGroupListItemCompany";

export interface ICompanyGroupListItem {
    id: string;
    code: string;
    name: string;
    comment: string;
    companies: ICompanyGroupListItemCompany[];
}

export class CompanyGroupListItem implements ICompanyGroupListItem {
    id: string;
    code: string;
    name: string;
    comment: string;
    companies: CompanyGroupListItemCompany[];

    constructor();
    constructor(obj: ICompanyGroupListItem);
    constructor(obj?: any) {
        this.id = obj && obj.id || "";
        this.code = obj && obj.code || "";
        this.name = obj && obj.name || "";
        this.comment = obj && obj.comment || "";
        this.companies = Base.getTypedArray(obj ? obj.companies : null, CompanyGroupListItemCompany);
    }
    
    static sortCompanyGroupListItems(items: ICompanyGroupListItem[], column: string, asc: boolean): ICompanyGroupListItem[] {
        if (!items && items.length < 2) return items;
        if (column === "name") {
            return items.sort((a: ICompanyGroupListItem, b: ICompanyGroupListItem) => { return (!a || !b) ? 0 : ((asc ? 1 : -1) * Base.strCompare(a.name, b.name)); });
        } else if (column === "comment") {
            return items.sort((a: ICompanyGroupListItem, b: ICompanyGroupListItem) => { return (!a || !b) ? 0 : ((asc ? 1 : -1) * Base.strCompare(a.comment, b.comment)); });
        } else {
            return items.sort((a: ICompanyGroupListItem, b: ICompanyGroupListItem) => { return (!a || !b) ? 0 : ((asc ? 1 : -1) * Base.strCompare(a.code, b.code)); });
        }
    }
}